var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkModeIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#555D76",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10 2.5h.328a6.25 6.25 0 0 0 6.6 10.371A7.5 7.5 0 1 1 10 2.493zM14.167 3.333A1.667 1.667 0 0 0 15.833 5a1.667 1.667 0 0 0-1.666 1.666A1.667 1.667 0 0 0 12.5 5a1.667 1.667 0 0 0 1.667-1.667M15.833 9.166H17.5m-.834-.833V10"
})));
export default SvgDarkModeIcon;